module.exports = __webpack_public_path__ + "static/img/channel-2-3.8241f1c3.png";